"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InputError = exports.InputContainer = exports.Input = void 0;

var _borderRadius = require("@r1-frontend/ui-react/tokens/borderRadius");

var _colors = require("@r1-frontend/ui-react/tokens/colors");

var _fonts = require("@r1-frontend/ui-react/tokens/fonts");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _templateObject, _templateObject2, _templateObject3;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var InputContainer = _styledComponents["default"].div.withConfig({
  displayName: "styles__InputContainer",
  componentId: "sc-1dsvarn-0"
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    width: 100%;\n    margin-bottom: 20px;\n    position: relative;\n    flex-direction: column;\n"])));

exports.InputContainer = InputContainer;

var Input = _styledComponents["default"].input.withConfig({
  displayName: "styles__Input",
  componentId: "sc-1dsvarn-1"
})(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    height: 48px;\n    width: 100%;\n    padding: 14px 0 14px 16px;\n    ", ";\n    color: ", ";\n    border: 2px solid ", ";\n    border-radius: ", ";\n    transition: border 0.2s ease-in;\n    outline: none;\n    box-shadow: none;\n    box-sizing: border-box;\n\n    &:not(:placeholder-shown) {\n        border-color: ", ";\n    }\n\n    &:focus, &:hover {\n        border-color: ", ";\n    }\n\n    &:disabled {\n        border-color: ", ";\n        background-color: ", ";\n        color: ", ";\n    }\n\n    &::placeholder {\n        color: ", ";\n    }\n\n    &::-ms-clear,\n    &::-ms-reveal,\n    &:focus::-ms-clear, ::-ms-reveal {\n        display: none !important;\n    }\n\n    &[type=number]::-webkit-inner-spin-button,\n    &[type=number]::-webkit-outer-spin-button {\n        -webkit-appearance: none;\n        margin: 0;\n    }\n\n    -webkit-text-security: ", "!important;\n"])), _fonts.FONTS.XS, _colors.COLORS.TextPrimary, function (p) {
  return p.isNotValid ? _colors.COLORS.Error : _colors.COLORS.BgSecondary;
}, _borderRadius.BorderRadius.componentRadius, function (p) {
  return p.isNotValid ? _colors.COLORS.Error : _colors.COLORS.GRAY_LIGHT;
}, function (p) {
  return p.isNotValid ? _colors.COLORS.Error : _colors.COLORS.GRAY_DARK;
}, _colors.COLORS.BgSecondary, _colors.COLORS.BgSecondary, _colors.COLORS.TextDisabled, _colors.COLORS.TextDisabled, function (p) {
  return p.showText ? 'none' : 'disc';
});

exports.Input = Input;

var InputError = _styledComponents["default"].p.withConfig({
  displayName: "styles__InputError",
  componentId: "sc-1dsvarn-2"
})(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    display: block;\n    ", ";\n    margin: 0;\n    color: ", ";\n    transition: opacity 0.2s ease-in-out;\n"])), _fonts.FONTS.XXS, _colors.COLORS.Error);

exports.InputError = InputError;